/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Automated process trigger
 */
export enum AutomatedProcessTrigger {
  DATABOX_MESSAGE_RECEIVED = 'DATABOX_MESSAGE_RECEIVED',
  EMAIL_MESSAGE_RECEIVED = 'EMAIL_MESSAGE_RECEIVED',
  FILE_CLOSED = 'FILE_CLOSED',
  DOCUMENT_CREATED = 'DOCUMENT_CREATED',
  DOCUMENT_SETTLED = 'DOCUMENT_SETTLED',
  DOCUMENT_MOVED_TO_SHARED_FOLDER = 'DOCUMENT_MOVED_TO_SHARED_FOLDER',
  FILE_MOVED_TO_SHARED_FOLDER = 'FILE_MOVED_TO_SHARED_FOLDER',
  DOCUMENT_RECLASSIFIED = 'DOCUMENT_RECLASSIFIED',
  FILE_RECLASSIFIED = 'FILE_RECLASSIFIED',
  DOCUMENT_RETURNED_FROM_EXTERNAL_APP = 'DOCUMENT_RETURNED_FROM_EXTERNAL_APP',
  FILE_RETURNED_FROM_EXTERNAL_APP = 'FILE_RETURNED_FROM_EXTERNAL_APP',
  DOCUMENT_METADATA_UPDATED = 'DOCUMENT_METADATA_UPDATED',
  FILE_METADATA_UPDATED = 'FILE_METADATA_UPDATED',
  DOCUMENT_STATUS_CHANGED = 'DOCUMENT_STATUS_CHANGED',
  FILE_STATUS_CHANGED = 'FILE_STATUS_CHANGED',
  CONSIGNMENT_STATUS_CHANGED = 'CONSIGNMENT_STATUS_CHANGED'
}
